import React, { Fragment } from 'react';
import { observer, inject } from 'mobx-react';

import InputField from '~/common/components/InputField';
import Select from '~/common/components/Select';
import Checkbox from '~/common/components/Checkbox';
import Tracking from '~/common/utils/gaTracking';
import { mapEcommerceItems } from '~/common/utils/trackingHelpers';

// Import Stylesheet
import styles from './billing-info.css';

@inject('formsStore', 'checkoutStore', 'contentStore', 'locationStore', 'upgradeStore', 'flexFrameStore')
@observer
export default class BillingInfo extends React.Component {
    state = { useSame: false };
    constructor(props) {
        super(props);
        const tracking = new Tracking();
        this.trackCheckoutStep = () => {
            tracking.trackBeginCheckout({
                step: 3,
                ecommerce: mapEcommerceItems({
                    selectedPlan: props.checkoutStore.selectedPlan,
                    billingPeriod: props.formsStore.BillingPeriod,
                    currencyCode: props.contentStore.contentData.CurrencyCode,
                    licenseSelector: props.formsStore.LicenseSelector,
                    selectedAddons: props.checkoutStore.selectedAddons
                })
            });
        };
    }

    componentDidMount() {
        const { locationStore } = this.props;

        // get list of countries
        if (locationStore.countries.length === 0) locationStore.getCountries();
    }

    onBlurBillingAddress(e) {
        this.props.formsStore[`${e.target.getAttribute('name')}Validation`]();
    }

    setCountries() {
        const { locationStore, checkoutStore, upgradeStore } = this.props;
        if (!locationStore.fetchedCountries) return <option key="countries-loading" value="">Loading</option>;
        !checkoutStore.existingUserCheck && upgradeStore.loadPreviousCC();
        return locationStore.countries.map(country => <option key={`country-${country.CountryCode}`} value={country.CountryCode}>{country.CountryName}</option>);
    }

    selectCountry(ev) {
        const { formsStore, locationStore, flexFrameStore } = this.props;

        if (ev.target.value !== formsStore.CountryCode) {
            formsStore.setFormData('CountryCode', ev.target.value);
            // clear previous selected state
            formsStore.setFormData('StateCode', '');

            formsStore.clearFieldError('StateCode', '');
            // validate field
            formsStore.CountryCodeValidation();
            // set the country to no have to state until is it needed
            locationStore.setCountryHasStates(false);
            // find the selected country in the
            if (!formsStore.doesFormHaveErrors(['CountryCode'])) {
                const country = locationStore.countries.find((cntry) => {
                    return cntry.CountryCode === formsStore.CountryCode;
                });

                if (country.States) {
                    locationStore.getStates(country);
                }
            }

            // reinitialize flex form with country code
            // const data = {
            //     hostName: window.location.origin,
            //     country: ev.target.value
            // };
            // reset existing keyId to prevent loading the same microform
            flexFrameStore.keyId = null;
            flexFrameStore.setCreatingMicroform(true);
            // rebuild a microform
            // flexFrameStore.getFlexKey(data);
            // set error on
            flexFrameStore.setIsCardValid('CreditCard', false);
        }
    }

    // hydrate states select input
    setStates() {
        return this.props.locationStore.states.map(state => <option key={`state-${state.StateCode}`} value={state.StateCode} >{state.StateName}</option>);
    }

    selectState(ev) {
        const {formsStore} = this.props;
        if (ev.target.value !== formsStore.StateCode) {
            formsStore.setFormData('StateCode', ev.target.value);
            // validate field
            this.props.formsStore.StateCodeValidation();
        }
    }

    toggleUseSame() {
        this.props.formsStore.setFormData('UseSame', !this.props.formsStore.UseSame);
    }

    render() {
        const {
            FirstName,
            LastName,
            FirstNameValid,
            LastNameValid,
            BillingFirstName,
            BillingLastName,
            BillingFirstNameError,
            BillingFirstNameValid,
            BillingLastNameValid,
            BillingLastNameError,
            Street1,
            Street1Error,
            Street1Valid,
            City,
            CityError,
            CityValid,
            StateCode,
            StateCodeError,
            StateCodeValid,
            CountryCode,
            CountryCodeError,
            CountryCodeValid,
            ZipCode,
            ZipCodeError,
            ZipCodeValid,
            ContactPhone,
            ContactPhoneError,
            ContactPhoneValid,
            UseSame
        } = this.props.formsStore;

        const { fetchedCountries, countryHasStates } = this.props.locationStore;
        const { labelContent } = this.props.contentStore;
        const { isUpgradeFlow, existingPaymentMethodKey } = this.props.checkoutStore;

        return (
            <div className="billing-info">
                <h2>{ labelContent.BillingInformation}</h2>
                {!isUpgradeFlow &&
                    <div className={styles['checkbox-wrapper']} onClick={() => this.toggleUseSame()}>
                        <Checkbox
                            checked={UseSame}
                            id="UseSame"
                            name="UseSame"
                        />
                        <label htmlFor="UseSame">{labelContent.UseTheSameNameFromMyAccount}</label>
                    </div>
                }
                <div className={styles.grid}>
                    {UseSame && !isUpgradeFlow ?
                        <Fragment>
                            <InputField
                                allowedCharacters=" -'"
                                autoComplete="cc-first-name"
                                defaultValue={FirstName}
                                disabled={true}
                                id="name-on-card"
                                inputRef={(el) => { this.billingFirstName = el; }}
                                label={labelContent.FirstName}
                                maxLength={50}
                                name="FirstName"
                                restrictCharacters="latinOnly"
                                type="text"
                                valid={FirstNameValid}
                                wrapperClass={styles['cc-first-name']}
                            />
                            <InputField
                                allowedCharacters="-'"
                                autoComplete="cc-last-name"
                                defaultValue={LastName}
                                disabled={true}
                                id="name-on-card2"
                                inputRef={(el) => { this.billingLastName = el; }}
                                label={labelContent.LastName}
                                maxLength={50}
                                name="LastName"
                                restrictCharacters="latinOnly"
                                type="text"
                                valid={LastNameValid}
                                wrapperClass={styles['cc-last-name']}
                            />
                        </Fragment>

                        :

                        <Fragment>
                            <InputField
                                allowedCharacters=" -'"
                                autoComplete="cc-first-name"
                                defaultValue={BillingFirstName}
                                error={BillingFirstNameError}
                                id="name-on-card"
                                label={labelContent.FirstName}
                                maxLength={50}
                                name="BillingFirstName"
                                onBlur={() => this.props.formsStore.BillingFirstNameValidation()}
                                restrictCharacters="latinOnly"
                                type="text"
                                valid={BillingFirstNameValid}
                                wrapperClass={styles['cc-first-name']}
                            />
                            <InputField
                                allowedCharacters="-'"
                                autoComplete="cc-last-name"
                                defaultValue={BillingLastName}
                                error={BillingLastNameError}
                                id="name-on-card2"
                                label={labelContent.LastName}
                                maxLength={50}
                                name="BillingLastName"
                                onBlur={() => this.props.formsStore.BillingLastNameValidation()}
                                restrictCharacters="latinOnly"
                                type="text"
                                valid={BillingLastNameValid}
                                wrapperClass={styles['cc-last-name']}
                            />
                        </Fragment>
                    }
                    <InputField
                        allowedCharacters=" #,."
                        autoComplete="street-address"
                        defaultValue={Street1}
                        error={Street1Error}
                        id="street-address"
                        label={labelContent.Address}
                        name="Street1"
                        onBlur={e => this.onBlurBillingAddress(e)}
                        onFocus={() => this.trackCheckoutStep()}
                        restrictCharacters="latinNumericOnly"
                        type="text"
                        valid={Street1Valid}
                        wrapperClass={styles.address}
                    />
                    <Select
                        disabled={!fetchedCountries || existingPaymentMethodKey}
                        error={CountryCodeError}
                        id="country"
                        label={labelContent.Country}
                        name="CountryCode"
                        onChange={(e) => { this.selectCountry(e); this.trackCheckoutStep(); }}
                        selected={CountryCode}
                        valid={CountryCodeValid}
                        value={CountryCode}
                        wrapperClass={styles.country}
                    >
                        {this.setCountries()}
                    </Select>
                    <InputField
                        allowedCharacters=" "
                        autoComplete="address-level2"
                        defaultValue={City}
                        error={CityError}
                        id="city"
                        label={labelContent.City}
                        name="City"
                        onBlur={e => this.onBlurBillingAddress(e)}
                        onFocus={() => this.trackCheckoutStep()}
                        restrictCharacters="latinOnly"
                        type="text"
                        valid={CityValid}
                        wrapperClass={styles.city}
                    />
                    {countryHasStates ?
                        <Select
                            disabled={!countryHasStates}
                            error={StateCodeError}
                            id="state"
                            label={labelContent.State}
                            name="StateCode"
                            onChange={(e) => { this.selectState(e); this.trackCheckoutStep(); }}
                            selected={StateCode}
                            valid={StateCodeValid}
                            value={StateCode}
                            wrapperClass={styles.state}
                        >
                            {this.setStates()}
                        </Select>
                        :
                        <InputField
                            allowedCharacters=" "
                            autoComplete="address-level2"
                            defaultValue={StateCode}
                            error={StateCodeError}
                            id="state2"
                            label={labelContent.State}
                            name="StateCode"
                            onBlur={() => this.props.formsStore.StateCodeValidation()}
                            onFocus={() => this.trackCheckoutStep()}
                            restrictCharacters="latinOnly"
                            type="text"
                            valid={StateCodeValid}
                            wrapperClass={styles.state}
                        />
                    }
                    <InputField
                        allowedCharacters=" -"
                        autoComplete="postal-code"
                        defaultValue={ZipCode}
                        error={ZipCodeError}
                        id="zipcode"
                        label={labelContent.PostalCode}
                        maxLength={12}
                        minCharacters={3}
                        name="ZipCode"
                        onBlur={e => this.onBlurBillingAddress(e)}
                        onFocus={() => this.trackCheckoutStep()}
                        restrictCharacters="latinNumericOnly"
                        type="text"
                        valid={ZipCodeValid}
                        wrapperClass={styles.zipcode}
                    />
                    <InputField
                        allowedCharacters=" "
                        autofill="phone"
                        defaultValue={ContactPhone}
                        error={ContactPhoneError}
                        id="contact-number"
                        label={labelContent.Phone}
                        name="ContactPhone"
                        onBlur={() => this.props.formsStore.ContactPhoneValidation()}
                        restrictCharacters="numericOnly"
                        type="tel"
                        valid={ContactPhoneValid}
                        wrapperClass={styles.phone}
                    />
                </div>
            </div>
        );
    }
}
